import { SR_API_ACTION_GET_BREED_RESTRICTIONS } from 'api/actionTypes';

export default async function loadBreedRestrictionDefinitions({ state, apiClient }) {
  const statePath = ['breedRestrictions', 'definitions'];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_GET_BREED_RESTRICTIONS,
    state: state,
    onSuccess(breedRestrictions) {
      state.set(statePath, breedRestrictions);
    },
  });
}
